module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress-2.0.1c638e51.svg";